export const featureList = [
    "Comprehensive Suite of Project Management Tools For Managing Assets",
    "Unlimited Storage & Organization For All File Types",
    "Fully Tailored Platform Aligned With Your Brand Identity",
    "Organize Projects With Restricted Access To Essential Items",
    "Isolated Sandbox For Safe Creative Collaboration",
    "Streamlined Processes To Boost Productivity For Your Artists",
    "Advanced Protection For Your Intellectual Property",
];

export const majorPlanFeatures = [
    "Upload and store up to 1TB of music files and stems",
    "Have your music highlighted at the top of our 'Featured Section'",
    "Shoutout in our emails and on social media to tens of thousands of users",
    "Inner circle access to select musicians and producers in our network",
    "Priority access to our newest creative music tools before they launch",
];

export const minorPlanFeatures = [
    "Enjoy our robust suite of AI-based music organization tools",
    "Upload and store up to 500GB of music files and stems",
    "Share tracks publicly or privately with full access control",
    "Gain access to our exclusive artist network for collaborations",
    "Add music projects to our Explore page for discoverability",
    "Project manage tracks and stems with integrated version control",
    "Message our network of users with advanced encryption",
    "Distribute music to all major DSPs like Spotify (Coming Soon)",
    "Revenue and royalties management dashboard (Coming Soon)",
];

export const studioPlanFeatures = [
    "1TB of Optimized Music & File Storage",
    "Advanced AI-Based Music Organization",
    "Tracks & NFTs Added to 'Featured Section'",
    "Profile, Tracks, & NFTs Highlighted on Website",
    "Social Media Promotion on OmMuse Socials",
    "Discounted Dolby.io AI Mastering ($4.99/track)",
    "Discounted Smart Contract Minting ($9.99/track)",
    "Shoutout on OmMuse Social Media Channels",
];

export const openMailToLink = (): void => {
    const mailtoLink = `mailto:hello@ommuse.com`;
    const newTab = window.open(mailtoLink);

    if (newTab && typeof newTab.focus === "function") {
        newTab.focus();
    } else {
        window.location.href = mailtoLink;
    }
};
